import { useIntl } from 'react-intl';

import messages from '@/components/emotion-detector/messages';
import { formatTime } from '@/utils/app/formatTime';
import back15Icon from 'icons/back-15-filled.svg';
import forward15Icon from 'icons/forward-15-filled.svg';
import stopIcon from 'icons/stop-filled.svg';

import { MobileTransportIcons, SeekBarContainer, Time, TransportIcons, TransportWrapper } from '../styles';
import { CurrentAudio } from '../types';
import SeekBar from './SeekBar';
import TransportIcon from './TransportIcon';
import { getPlayPauseIcon, getPlayPauseLabel } from './utils';

interface TransportProps {
	currentAudio: CurrentAudio;
	onPlayPause: () => void;
	onBack15: () => void;
	onForward15: () => void;
	onStop: () => void;
	onSeek: (time: number) => void;
}

export default function Transport({
	currentAudio,
	onPlayPause,
	onBack15,
	onForward15,
	onStop,
	onSeek,
}: TransportProps) {
	const { formatMessage } = useIntl();
	return (
		<TransportWrapper>
			{/* Desktop transport icons */}
			<TransportIcons>
				<TransportIcon
					aria-label={formatMessage(messages.audioPlayerRewind)}
					icon={back15Icon}
					onClick={onBack15}
				/>
				<TransportIcon
					aria-label={getPlayPauseLabel(currentAudio.isPlaying, formatMessage)}
					isPrimary
					icon={getPlayPauseIcon(currentAudio.isPlaying)}
					onClick={onPlayPause}
				/>
				<TransportIcon
					aria-label={formatMessage(messages.audioPlayerFastForward)}
					icon={forward15Icon}
					onClick={onForward15}
				/>
				<TransportIcon
					aria-label={formatMessage(messages.audioPlayerStop)}
					icon={stopIcon}
					onClick={onStop}
				/>
			</TransportIcons>

			{/* Seek bar with time display */}
			<SeekBarContainer>
				<Time>{formatTime(currentAudio.currentTime)}</Time>
				<SeekBar currentTime={currentAudio.currentTime} duration={currentAudio.duration} onSeek={onSeek} />
				<Time>{currentAudio.duration && formatTime(currentAudio.duration)}</Time>
			</SeekBarContainer>

			{/* Mobile play/pause button */}
			<MobileTransportIcons>
				<TransportIcon
					aria-label={getPlayPauseLabel(currentAudio.isPlaying, formatMessage)}
					isPrimary
					icon={getPlayPauseIcon(currentAudio.isPlaying)}
					onClick={onPlayPause}
				/>
			</MobileTransportIcons>
		</TransportWrapper>
	);
}
